class RedirectFrameFinder extends HTMLElement{
    constructor(){
        super();
        this.url = CookieUtils.getCookie('frame_finder_filter_url') || this.dataset.collection;
    }

    connectedCallback(){
        const redirectButton = this.querySelector('[data-reset="reset"]');
        if(redirectButton){
            redirectButton.addEventListener('click', (e)=> this.handleRedirect(e));
        }
    }

    handleRedirect(e){
        e.preventDefault();
        if(this.url){
            window.location.href = this.url;
        }
    }
}

customElements.define('redirect-frame-finder', RedirectFrameFinder);